module.exports = __webpack_public_path__ + "static/media/Datareport.8c695867.gif";